import { createSlice } from '../factory';
export const loadingSlice = createSlice({
    name: 'loading',
    initialState: {
        loadingStates: {},
        errorStates: {},
    },
    actions: ({ setSlice, getSlice, }) => ({
        startLoading: (key) => {
            setSlice(prev => ({
                loadingStates: { ...prev.loadingStates, [key]: true },
            }));
        },
        finishLoading: (key) => {
            const next = { ...getSlice().loadingStates };
            delete next[key];
            setSlice({ loadingStates: next });
        },
        isAnyLoading: () => Object.keys(getSlice().loadingStates).length > 0,
        isOperationLoading: (key) => Boolean(getSlice().loadingStates[key]),
        clearAllLoading: () => setSlice({ loadingStates: {} }),
        setError: (key, message) => {
            setSlice(prev => ({
                errorStates: { ...prev.errorStates, [key]: message },
            }));
        },
        clearError: (key) => {
            const next = { ...getSlice().errorStates };
            delete next[key];
            setSlice({ errorStates: next });
        },
        clearAllErrors: () => setSlice({ errorStates: {} }),
        getError: (key) => getSlice().errorStates[key] ?? null,
        isOperationError: (key) => Boolean(getSlice().errorStates[key]),
        isAnyError: () => Object.keys(getSlice().errorStates).length > 0,
        withLoading: async (key, fn) => {
            const { startLoading, finishLoading } = (() => {
                const s = getSlice();
                // Methods bound on returned state; fallback to local closures if not present
                return {
                    startLoading: (k) => setSlice(prev => ({
                        loadingStates: { ...prev.loadingStates, [k]: true },
                    })),
                    finishLoading: (k) => {
                        const map = { ...getSlice().loadingStates };
                        delete map[k];
                        setSlice({ loadingStates: map });
                    },
                    ...s,
                };
            })();
            startLoading(key);
            try {
                return await fn();
            }
            finally {
                finishLoading(key);
            }
        },
        waitForOperation: (key) => new Promise(resolve => {
            const check = () => {
                if (!getSlice().loadingStates[key]) {
                    clearInterval(interval);
                    resolve();
                }
            };
            check();
            const interval = setInterval(check, 50);
        }),
        getLoadingCount: () => Object.keys(getSlice().loadingStates).length,
        listActiveOperations: () => Object.keys(getSlice().loadingStates),
        isAnyOf: (keys) => keys.some(k => Boolean(getSlice().loadingStates[k])),
        groupLoadingPrefix: (prefix) => Object.keys(getSlice().loadingStates).some(k => k.startsWith(prefix)),
        clearByPrefix: (prefix) => {
            const next = Object.fromEntries(Object.entries(getSlice().loadingStates).filter(([k]) => !k.startsWith(prefix)));
            setSlice({ loadingStates: next });
        },
    }),
});
// Consumers and factory can import `loadingSlice` directly (it includes name + build)
